import React, { FC } from 'react';
import styled from '@emotion/native';
import Text from '@components/1-atoms/Text';
import { Row, Spacer } from '@components/1-atoms/Miscellaneous';


export const TabContainer = styled(Row)`
  justify-content: flex-start;
  height: 60px;
  padding-left: 12px;
  margin-bottom: -15px;
  // margin-left: -24px;
  margin-left: -12px;
  width: ${({ theme }: any) => `${Math.min(500, theme.contentWidth)}px` };
  flex-direction: row;
  gap: 6px;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  flex-wrap: nowrap;
`;

const Container = styled.View`
position: relative;
top: 0;
left: 0;
align-items: center;
display: flex;
flex-direction: row;
flex-wrap: nowrap;
padding: 0;
width: 100%;
justify-content: space-between;
height: ${({ theme }: any) => theme.headerHeight + 'px'};
`;

const Content = styled.TouchableOpacity`
  background-color: ${({ bg }: any) => bg || '#FFF' };
  align-self: center;
  justify-content: center;
  flex-direction: column;
  padding: 9px;
  
  min-width: 86px;
  flex: 0 0 auto;
  
  ${props => props.selected && `
    margin-top: -3px;
    border-color: #C0C0C0;
    border-width: 1px;
    border-radius: 24px;
  `}
`;



type Props = {
  onPress?: () => void;
  name: string;
  selected?: boolean;
};


const Tab: FC<Props> = ({ onPress, name, selected, ...props }) => {
  return (
    <Container>
      <Content onPress={onPress} selected={selected} {...props}>

        <Text align='center' xsmall color={selected ? "#005ACE" : '#C0C0C0'}>{name}</Text>

      </Content>
    </Container>
  );
};

export default Tab;